import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import logger from 'redux-logger-simple';
import { persistStore, persistReducer } from 'redux-persist';
import storageLocal from 'redux-persist/lib/storage/session';
import AuthReducer from './Reducers/AuthReducer';
import ProfileReducer from './Reducers/ProfileReducer';
import SideBarReducer from './Reducers/SideBarReducer';
import ContainerReducer from './Reducers/ContainerReducer';
import SlideNotificationReducer from './Reducers/SlideNotification';
import TutoReducer from './Reducers/TutoReducer';
import ShowRatingModalReducer from './Reducers/ShowRatingModalReducer';
import DocumentsReducer from './Reducers/DocumentsReducer';
import LoaderReducer from './Reducers/LoaderReducer';
const persistConfig = {
  key: 'root',
  timeout: null,
  storage: storageLocal,
  whitelist: ['auth', 'sideBar', 'tuto', 'profile'],
  blacklist: ['container', 'slideNotification', 'loader', 'DocumentsReducer']
};
const middleware = [thunkMiddleware];
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware, logger));
const reducers = combineReducers({
  auth: AuthReducer,
  sideBar: SideBarReducer,
  container: ContainerReducer,
  slideNotification: SlideNotificationReducer,
  tuto: TutoReducer,
  rating: ShowRatingModalReducer,
  profile: ProfileReducer,
  DocumentsReducer,
  loader: LoaderReducer
});

const persistedReducers = persistReducer(persistConfig, reducers);

const Store = createStore(persistedReducers, enhancer);

export default Store;
export const persistor = persistStore(Store);
export const middlewares = middleware;
